/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

import SavedRowModel from 'cio/models/saved-row';

interface SavedRowsDeleteConfirmationArgs {
  savedRow: SavedRowModel;
  disabled: boolean;
  onCancelDelete: () => unknown;
  onConfirmDelete: () => unknown;
}

export default class SavedRowsDeleteConfirmation extends Component<SavedRowsDeleteConfirmationArgs> {
  @tracked hasFailedToDelete = false;

  deleteSavedRowTask = task(async () => {
    try {
      await this.args.onConfirmDelete();
    } catch {
      this.hasFailedToDelete = true;
    }
  });
}
